export default "__VITE_ASSET__n424TeGU__"